import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { navLinks, siteInfo } from "@/mocks/site";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";
  const light = isHome && !scrolled;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-2.5 group">
            <span className="w-10 h-10 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-xl">
              <i className="ri-plant-line" />
            </span>
            <span className="leading-tight">
              <span
                className={`block font-heading font-bold text-lg md:text-xl tracking-wide transition-colors ${
                  light ? "text-background-50" : "text-foreground-950"
                }`}
              >
                瓜田黑料
              </span>
              <span
                className={`hidden sm:block text-[11px] tracking-[0.2em] transition-colors ${
                  light ? "text-background-200/80" : "text-foreground-500"
                }`}
              >
                TOP LIST · MOMENTS
              </span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <NavLink
                key={link.path}
                to={link.path}
                end={link.path === "/"}
                className={({ isActive }) => {
                  if (isActive) {
                    return `px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                      light
                        ? "text-background-50 bg-background-50/15"
                        : "text-primary-600 bg-primary-50"
                    }`;
                  }
                  return `px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                    light
                      ? "text-background-100/90 hover:text-background-50 hover:bg-background-50/10"
                      : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                  }`;
                }}
              >
                {link.name}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <span
              className={`text-xs whitespace-nowrap transition-colors ${
                light ? "text-background-200/80" : "text-foreground-500"
              }`}
            >
              <i className="ri-shield-check-line mr-1 text-accent-600" />
              理性吃瓜
            </span>
            <Link
              to="/rankings"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-trophy-line" />
              开始补课
            </Link>
          </div>

          <button
            type="button"
            aria-label="打开导航菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-2xl transition-colors ${
              light ? "bg-background-50/15 text-background-50" : "bg-background-100 text-foreground-800"
            }`}
          >
            <i className={menuOpen ? "ri-close-line" : "ri-menu-line"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-b border-background-200 px-4 pb-5 pt-2">
          <nav className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <NavLink
                key={link.path}
                to={link.path}
                end={link.path === "/"}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-md text-sm font-medium ${
                    isActive
                      ? "text-primary-600 bg-primary-50"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {link.name}
              </NavLink>
            ))}
          </nav>
          <Link
            to="/rankings"
            className="mt-3 inline-flex w-full items-center justify-center gap-1.5 px-5 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium"
          >
            <i className="ri-trophy-line" />
            开始补课 · {siteInfo.slogan}
          </Link>
        </div>
      )}
    </header>
  );
}